import {Nullable} from "./caos-def";

/**
 * Checks if an array contains a value
 * @param array
 * @param value
 */
export function contains<T>(array: Array<T>, value: T): boolean {
    return array.indexOf(value) >= 0;
}

/**
 * Creates a filter function to test an array for existence of values
 * @param array
 */
export function containsFunction<T>(array: Array<T>): (value: T) => boolean {
    return (value: T) => {
        return array.indexOf(value) >= 0;
    }
}

function onlyUnique<T>(value: T, index: number, array: T[]): boolean {
    return array.indexOf(value) === index;
}

// usage example:
export function unique<T>(array: T[]): T[] {
    return array.filter(onlyUnique);
}


export function notNull<T>(item: Nullable<T>): item is Exclude<T, null> {
    return item != null;
}